let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6D6Cg")).then(() => parcelRequire('a7ZyQ'));